import React, { FC } from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

export const AttachmentIcon: FC<Props> = ({ className, width = 10, height = 19, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 10 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.91667 4.16667V13.75C7.91667 15.5917 6.425 17.0833 4.58333 17.0833C2.74167 17.0833 1.25 15.5917 1.25 13.75V3.33333C1.25 2.18333 2.18333 1.25 3.33333 1.25C4.48333 1.25 5.41667 2.18333 5.41667 3.33333V12.0833C5.41667 12.5417 5.04167 12.9167 4.58333 12.9167C4.125 12.9167 3.75 12.5417 3.75 12.0833V4.16667H2.5V12.0833C2.5 13.2333 3.43333 14.1667 4.58333 14.1667C5.73333 14.1667 6.66667 13.2333 6.66667 12.0833V3.33333C6.66667 1.49167 5.175 0 3.33333 0C1.49167 0 0 1.49167 0 3.33333V13.75C0 16.2833 2.05 18.3333 4.58333 18.3333C7.11667 18.3333 9.16667 16.2833 9.16667 13.75V4.16667H7.91667Z"
        fill={color}
      />
    </svg>
  );
};
